import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function SeychellesJurisdiction() {

    return (
        <main className='main'>
            <SEO
                title="Seychelles Offshore | Company Formation & Licensing Hub"
                description="Set up offshore companies in Seychelles. FSA-regulated hub for company formation, fintech, brokerage, and wealth management solutions."
                keywords="Seychelles offshore, Seychelles company formation, FSA Seychelles regulation, offshore licensing Seychelles, fintech Seychelles, brokerage license Seychelles, wealth management Seychelles, offshore jurisdiction Indian Ocean"
                url="/seychelles-jurisdiction"
            />
            <IntroSection
                title="Seychelles as a Jurisdiction"
                subtitle="A Leading Offshore Financial & Corporate Hub in the Indian Ocean"
                description="Seychelles is a well-known international financial center offering company formation, licensing, and wealth management solutions. Its strategic location between Africa, Asia, and Europe has made it a popular choice for traders, fintechs, asset managers, and brokers. The country is part of the Commonwealth, has a stable political system, and is home to the Financial Services Authority (FSA), one of the most recognized regulators among offshore centers."
                badges={[
                    "Forex Brokers",
                    "Funds & Asset Managers",
                    "Insurance & Trusts",
                    "IBCs & PSPs"
                ]}
                buttonText="Request a Seychelles Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/seychelles-jurisdiction.png')}
                imageAlt="Seychelles Offshore Financial Hub"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Seychelles?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "International Reputation",
                                        text: "Established offshore center since 1995."
                                    },
                                    {
                                        title: "Trusted Regulator",
                                        text: "Regulated by the FSA and Central Bank of Seychelles."
                                    },
                                    {
                                        title: "Popular Licenses",
                                        text: "Securities Dealer (forex), funds, insurance, and PSPs."
                                    },
                                    {
                                        title: "Tax Neutrality",
                                        text: "No tax on foreign-sourced income for IBCs."
                                    },
                                    {
                                        title: "Strategic Location",
                                        text: "Gateway to Africa, Asia, and Europe."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Structures & Services in Seychelles"
                        blocks={[
                            {
                                title: "International Business Companies (IBCs)",
                                items: [
                                    { text: "Most common vehicle for offshore activities." },
                                    { text: "Fast and cost-effective incorporation." },
                                    { text: "Used for trading, asset protection, holding, and fintech setups." }
                                ]
                            },
                            {
                                title: "Securities Dealer License (Forex & Brokerage)",
                                items: [
                                    { text: "Most popular license in Seychelles." },
                                    { text: "Covers forex, CFDs, and securities dealing." },
                                    { text: "Capital Requirement: USD 50,000." }
                                ]
                            },
                            {
                                title: "Banking Licenses",
                                items: [
                                    { text: "Issued by the Central Bank of Seychelles." },
                                    { text: "Domestic Banking License: full-service banking in Seychelles." },
                                    { text: "International Banking License: offshore banking for non-residents." }
                                ]
                            },
                            {
                                title: "Insurance Licenses",
                                items: [
                                    { text: "Life, non-life, reinsurance, and captives." },
                                    { text: "Popular for risk management and corporate structures." }
                                ]
                            },
                            {
                                title: "Funds & Asset Management",
                                items: [
                                    { text: "Public and private funds, fund managers, and advisors." },
                                    { text: "Alternative to BVI, Cayman, and Malta for fund setups." }
                                ]
                            },
                            {
                                title: "Trusts & Fiduciary Services",
                                items: [
                                    { text: "Trust company licenses and fiduciary services." },
                                    { text: "Used for estate planning, nominee services, and asset protection." }
                                ]
                            },
                            {
                                title: "Payments & FinTech",
                                items: [
                                    { text: "PSPs, remittance companies, and hybrid fintech structures." },
                                    { text: "Used for cross-border payments and crypto gateways." }
                                ]
                            },
                            {
                                title: "Gaming & iGaming Licenses",
                                items: [
                                    { text: "Covers online casinos, betting, and lotteries." },
                                    { text: "Competes with Curacao, Anjouan, and Western Sahara as an offshore option." }
                                ]
                            },
                            {
                                title: "Crypto / Digital Assets",
                                items: [
                                    { text: "No standalone CASP law, but crypto firms can register under Securities Dealer or PSP frameworks." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of Seychelles as a Jurisdiction'
                        services={[
                            {
                                title: "Global Recognition",
                                text: "Stronger reputation than smaller offshore centers (Mwali, Anjouan)."
                            },
                            {
                                title: "Affordable Licensing",
                                text: "Lower capital requirements for forex and fund licenses vs Malta/Cyprus."
                            },
                            {
                                title: "Tax-Friendly",
                                text: "Offshore IBCs are exempt from income tax."
                            },
                            {
                                title: "Compliance Balance",
                                text: "Regulated yet business-friendly environment."
                            },
                            {
                                title: "Strong in Forex",
                                text: "Preferred hub for online brokers."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Offshore Advisory in Seychelles'
                        items={[
                            { text: "Company formation (IBCs & local companies)." },
                            { text: "Securities Dealer (Forex Brokerage) License." },
                            { text: "Banking, insurance, and fund licensing." },
                            { text: "Trust and fiduciary setup." },
                            { text: "Payments & fintech licensing." },
                            { text: "Compliance & regulator relations with the FSA." }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a trusted offshore jurisdiction?"
                        description="Seychelles offers IBC formation, forex brokerage licenses, funds, and banking services, all regulated by the FSA."
                        buttonText="Book a Seychelles Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is Seychelles a respected offshore jurisdiction?",
        answer: "Yes — it is among the top-tier offshore centers, especially for forex brokers."
    },
    {
        question: "What is the most popular license in Seychelles?",
        answer: "The Securities Dealer License (forex brokerage)."
    },
    {
        question: "What’s the capital requirement for a forex license?",
        answer: "USD 50,000."
    },
    {
        question: "Are IBCs in Seychelles taxed?",
        answer: "No — foreign-sourced income is tax-exempt."
    },
    {
        question: "How long does company incorporation take?",
        answer: "1–2 weeks for an IBC."
    }
];

const testimonialsData = [
    {
        quote: "We licensed our forex brokerage in Seychelles. Offshore Advisory managed the FSA application from start to finish.",
        author: "Mark R.",
        role: "FX Broker"
    },
    {
        quote: "Seychelles IBCs are fast and affordable. Offshore Advisory guided us on compliance and banking.",
        author: "Elena K.",
        role: "FinTech Entrepreneur"
    }
];
